export const MAX_OPPORTUNITIES = 3;

export function normalizeOpportunitiesList(value) {
    if (Array.isArray(value)) return value;
    if (value?.id) return [value];
    return [];
}

export function isOpportunitySelected(selected, opportunityId) {
    if (!opportunityId) return false;
    return normalizeOpportunitiesList(selected).some((item) => item.id === opportunityId);
}

export function toggleOpportunitySelection(selected, opportunity, max = MAX_OPPORTUNITIES) {
    const list = normalizeOpportunitiesList(selected);
    const id = opportunity?.id;
    if (!id) return list;

    const index = list.findIndex((item) => item.id === id);
    if (index >= 0) {
        return list.filter((_, i) => i !== index);
    }
    if (list.length >= max) return list;
    return [...list, opportunity];
}

export function removeOpportunity(selected, opportunityId) {
    return normalizeOpportunitiesList(selected).filter((item) => item.id !== opportunityId);
}

export function getFollowUpOpportunities(followUp) {
    if (!followUp) return [];
    if (Array.isArray(followUp.opportunities)) return followUp.opportunities;
    if (followUp.opportunity) return normalizeOpportunitiesList(followUp.opportunity);
    return [];
}
